module.exports = __webpack_public_path__ + "static/media/opensans-semibold-webfont.54ccb61c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-semibold-webfont.woff
// module id = 1012
// module chunks = 0